import $ from "jquery";
import { initTinymce } from "./main";
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "forDownloadTypeDetail")
        return;
    initTinymce('Description', 300);
});
//# sourceMappingURL=forDownloadTypeDetail.js.map